import { render, staticRenderFns } from "./PointRate.vue?vue&type=template&id=2cdb428a&"
import script from "./PointRate.vue?vue&type=script&lang=ts&"
export * from "./PointRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports